const state = {
    windSelectIndex: 0,
    windDataIsShow: true,
    currentCallPhone: null,
    callStartTime: null, // 通话开始时间戳
}

const mutations = {
    SET_WINDSELECT: (state, index) => {
        state.windSelectIndex = index;
    },
    SET_DATAISSHOW: (state, isShow) => {
        state.windDataIsShow = isShow;
    },
    SET_CURRENT_CALL_PHONE: (state, phone) => {
        state.currentCallPhone = phone;
    },
    CLEAR_CURRENT_CALL_PHONE: (state) => {
        state.currentCallPhone = null;
    },
    SET_CALL_START_TIME: (state, startTime) => {
        state.callStartTime = startTime;
    },
    CLEAR_CALL_START_TIME: (state) => {
        state.callStartTime = null;
    },
    // ADD_VISITED_VIEW: (state, view) => {
    //     if (state.visitedViews.some(v => v.path === view.path)) return
    //     state.visitedViews.push(
    //         Object.assign({}, view, {
    //             title: view.meta.title || 'no-name'
    //         })
    //     )
    // },
}

const actions = {
    setWindSelectIndex({
        commit
    }, index) {
        commit('SET_WINDSELECT', index)
    },
    setWindDataIsShow({
        commit
    }, isShow) {
        commit('SET_DATAISSHOW', isShow)
    },
    setCurrentCallPhone({
        commit
    }, phone) {
        commit('SET_CURRENT_CALL_PHONE', phone)
    },
    clearCurrentCallPhone({
        commit
    }) {
        commit('CLEAR_CURRENT_CALL_PHONE')
    },
    setCallStartTime({
        commit
    }, startTime) {
        commit('SET_CALL_START_TIME', startTime)
    },
    clearCallStartTime({
        commit
    }) {
        commit('CLEAR_CALL_START_TIME')
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
